<template>
  <div class="download-page">
    <div class="container">
      <div class="download-card">
        <!-- 产品标题 -->
        <h1 class="product-title">
          <span class="highlight">toPDF</span>
          批量转换PDF利器
        </h1>

        <!-- 版本信息 -->
        <div class="version-info">
          <span class="version-tag">版本：1.6.0版</span>
          <span class="system-tag">支持操作系统：Windows 10、11</span>
        </div>

        <!-- 功能列表 -->
        <div class="features-section">
          <h2>基本功能：</h2>
          <ul class="feature-list">
            <li>支持一键拖选多个多种类型文件</li>
            <li>支持批量转换为合并的PDF文件</li>
            <li>支持批量转换为单独的PDF文件</li>
            <li>支持右键批量选择文件进行转换</li>
          </ul>
        </div>

        <!-- 下载按钮 -->
        <div class="download-section">
          <a href="https://topdf-download.oss-cn-beijing.aliyuncs.com/toPDF_Setup_1.6.0.zip" class="download-button">
            <span class="icon">↓</span>
            <span>立即下载</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Download'
}
</script>

<style scoped>
.download-page {
  min-height: 100vh;
  padding: 60px 0;
  background: linear-gradient(135deg, rgba(74, 144, 226, 0.1), rgba(66, 185, 131, 0.1));
}

.download-card {
  background: var(--white);
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  max-width: 800px;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.download-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(to right, var(--primary-color), var(--accent-color));
}

.product-title {
  font-size: 2.5rem;
  color: var(--secondary-color);
  text-align: center;
  margin-bottom: 30px;
  line-height: 1.4;
}

.highlight {
  color: var(--primary-color);
  font-weight: 700;
  font-size: 3rem;
  display: block;
  margin-bottom: 10px;
}

.version-info {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-bottom: 40px;
  flex-wrap: wrap;
}

.version-tag,
.system-tag {
  background: var(--light-gray);
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 1rem;
  color: var(--secondary-color);
}

.features-section {
  margin-bottom: 40px;
}

.features-section h2 {
  color: var(--secondary-color);
  font-size: 1.5rem;
  margin-bottom: 20px;
}

.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.feature-list li {
  position: relative;
  padding-left: 30px;
  margin-bottom: 15px;
  color: var(--secondary-color);
  font-size: 1.1rem;
}

.feature-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: var(--accent-color);
  font-weight: bold;
}

.download-section {
  text-align: center;
  margin-top: 40px;
}

.download-button {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: var(--primary-color);
  color: var(--white);
  padding: 15px 40px;
  border-radius: 30px;
  text-decoration: none;
  font-size: 1.2rem;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(74, 144, 226, 0.3);
}

.download-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(74, 144, 226, 0.4);
  background: var(--accent-color);
}

.download-button .icon {
  font-size: 1.4rem;
}

@media (max-width: 768px) {
  .download-page {
    padding: 30px 15px;
  }

  .download-card {
    padding: 30px 20px;
  }

  .product-title {
    font-size: 2rem;
  }

  .highlight {
    font-size: 2.5rem;
  }

  .version-info {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}
</style>